import moment from 'moment';

export const formatDate = (date) => {
  if (!date) return null;
  try {
    return moment(date).format('MMM DD, YYYY'); // eg:- Aug 06, 2024
  } catch (error) {
    return null;
  }
};

export const formatDateTime = (date) => {
  if (!date) return null;
  try {
    return moment(date).format('MMM D, YYYY h:mm A');
  } catch (error) {
    return null;
  }
};

export const customerTypes = {
  normal: 'Normal',
  commercial: 'Commercial',
};

export const productTypes = {
  service: 'Service',
  call: 'Call',
  inventory: 'Inventory',
  sms: 'SMS',
};

export const didTypes = {
  Local: 'Local',
  NGN: 'NGN',
  TF: 'TF',
  ITFS: 'ITFS',
};
export const didStatus = {
  available: 'Available',
  reserved: 'Reserved',
  allocated: 'Allocated',
  quarantine: 'Quarantine',
};
